//= require select2/dist/js/select2.min

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitToggler', 'submit']

  connect(){
    if (this.hasSubmitTogglerTarget) {
      $(this.submitTogglerTarget).on('select2:select', function (e) {
        this.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  toggleSubmit(event) {
    if (this.hasSubmitTarget) {
      if (event.currentTarget.value === '') {
        this.submitTarget.setAttribute('disabled', 'disabled');
      } else {
        this.submitTarget.removeAttribute('disabled');
      }
    }
  }
}
